import { RTKQueryTag } from 'src/common/constants';
import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

import { INFLUENCERS_CAMPAIGNS_URL } from './campaigns.constants';
import type { CampaignBodySchema, CampaignsData, CampaignsParams, PresignedUrlData } from './campaigns.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInfluencersCampaigns: builder.query<ApiResponse<CampaignsData>, CampaignsParams>({
      query: ({ page, limit, name, type }: CampaignsParams) => ({
        url: INFLUENCERS_CAMPAIGNS_URL,
        params: {
          page,
          limit,
          name,
          type,
        },
        method: 'GET',
      }),
      providesTags: [RTKQueryTag.InfluencerCampaigns],
    }),
    getInfluencersCampaignsPreSignedUrl: builder.query<ApiResponse<PresignedUrlData>, string>({
      query: (filename) => ({
        url: `${INFLUENCERS_CAMPAIGNS_URL}/pre-signed-url?filename=${filename}`,
        method: 'GET',
      }),
    }),
    createInfluencerCampaign: builder.mutation<ApiResponse<{ campaignId: string }>, CampaignBodySchema>({
      query: (body) => ({
        url: INFLUENCERS_CAMPAIGNS_URL,
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error) => (!error && result ? [{ type: RTKQueryTag.InfluencerCampaigns }] : []),
    }),
    updateInfluencerCampaign: builder.mutation<ApiResponse<{ campaignId: string }>, CampaignBodySchema>({
      query: ({ _id, ...body }) => ({
        url: `${INFLUENCERS_CAMPAIGNS_URL}/${_id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error) => (!error && result ? [{ type: RTKQueryTag.InfluencerCampaigns }] : []),
    }),
    removeInfluencerCampaign: builder.mutation<ApiResponse, { campaignId: string }>({
      query: ({ campaignId }) => ({
        url: `${INFLUENCERS_CAMPAIGNS_URL}/${campaignId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error) => (!error && result ? [{ type: RTKQueryTag.InfluencerCampaigns }] : []),
    }),
  }),
});

export const {
  useGetInfluencersCampaignsQuery,
  useLazyGetInfluencersCampaignsPreSignedUrlQuery,
  useCreateInfluencerCampaignMutation,
  useRemoveInfluencerCampaignMutation,
  useUpdateInfluencerCampaignMutation,
} = extendedApiSlice;
